import React, {Component} from 'react';
import {Button} from 'reactstrap';

class NavTab extends Component {
	render() {
		return (
			<div>
				<Button
					color={`${
						this.props.subsection === this.props.tabSection ? 'primary' : ''
					}`}
					onClick={() => {
						this.props.changeSubsection(this.props.tabSection);
					}}
					className="programNav"
					id={this.props.id}
				>
					{this.props.tabTitle}
				</Button>{' '}
			</div>
		);
	}
}

export default NavTab;



// WEBPACK FOOTER //
// ./src/components/NavTab.js